<template>
    <div id="print" class="big_cat_screen" style="background-color: #275ba9">
        <div class="back_nav" @click="backNav()"><img src="../../assets/back_nav.png"/></div>

        <!-- 背景 -->
        <div class="word_back" v-if="!isEmpty(objWordCard)">
            <div class="img_show">
                <div class="re-item">
                    <div class="re-item-front" @click="openClick()">
                        <img class="lazy_img" v-lazy="$qiNiuDomainBase + objWordCard.picture" alt="" />
                    </div>

                    <div class="re-item-back" @click="closeClick()">
                        <pre>{{objWordCard.chineseInterpretation}}</pre>
                    </div>
                    <div class="chinese_intro">中</div>
                </div>
            </div>
            <div class="word_audio">
                <div class="word" @click="playAudio(objWordCard.audio)">
                    <div class="audio_playing_white img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                    <img class="img_play" :style="{display: isPlaying ? 'none' : ''}" src="@/assets/volume_white.png" height="30" width="30"/>
                    <span>{{objWordCard.word}}</span>
                </div>
                <div class="sentence">
                    <span>{{objWordCard.exampleSentence}}</span>
                </div>
            </div>
        </div>

        <audio v-show="false" :src="audioUrl" id="musicMp3" @ended="playEnded" />
    </div>
</template>

<script>

    import $ from "jquery";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top', (height-width)/2 );
            vPrint.css('left', 0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                objWordCard: {},
                isPlaying: false,
                audioUrl: "",
            }
        },
        methods: {
            backNav:function(){
                this.$router.go(-1);
            },
            getStateWidth: function () {
                return this.getCount(this.$store.state.statusheight) > 22 ? 10 : 0;
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            showStatus:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            playAudio(audio) {
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlaying) {
                    musicMp3.pause();
                }

                that.audioUrl = that.$qiNiuDomainBase + audio;
                musicMp3.src = that.audioUrl;
                that.isPlayingFail = false;

                setTimeout(() => {
                    that.isPlaying = true;
                    let playPromise = musicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            that.isPlayingFail = true;
                            that.isPlaying = false;
                            let vError = JSON.stringify(e);
                            window.console.log("播放失败:playAudio:" + vError);
                        });
                    } else {
                        that.isPlayingFail = true;
                        that.isPlaying = false;
                        window.console.log("播放失败:playAudio");
                    }
                }, 200);
            },
            playEnded() {
                let that = this;
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();

                if (that.isPlaying) {
                    this.isPlaying = false;
                    // 播放完成自动开始评测
                }
            },
            openClick() {
                $(".re-item-front").addClass("open");
                $(".re-item-back").addClass("open");
                $(".chinese_intro").hide(500);
            },
            closeClick() {
                $(".re-item-front").removeClass("open");
                $(".re-item-back").removeClass("open");
                $(".chinese_intro").show(1000);
            },

        },
        beforeCreate() {
            let vWordId = parseInt(this.$route.query.wordId);
            let url = "bigCat6/getWordCard/" + vWordId;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.objWordCard = response.data;
                that.cardIndex = 0;

                that.hideStatusAndStopAudio();

                let wordAudio = that.objWordCard.audio;

                setTimeout(() => {
                    transformView();

                    setTimeout(function () {
                        if (!that.isEmpty(wordAudio)) {
                            that.playAudio(wordAudio);
                        }
                    }, 200);
                }, 100);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    img { pointer-events: none; }

    .big_cat_screen {
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }
    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .word_back {
        position: absolute;
        width: calc(190vmin - 104*1.9px);
        height: calc(100vmin - 104px);
        top: 74px;
        bottom: 30px;
        background-color: #0000006a;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        display: flex;
    }
    .word_back .img_show {
        margin: 30px;
    }
    .word_back .img_show img {
        width: calc(100vmin - 164px);
        height: calc(100vmin - 164px);
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }

    .word_back .word_audio {
        width: calc(90vmin - 123.6px);
        height: calc(100vmin - 104px);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        align-content: center;
    }
    .word_back .word {
        width: calc(90vmin - 123.6px);
        display: flex;
        justify-content: center;
    }
    .word_back .word .img_play {
        width: 30px;
        height: 30px;
        margin-right: 5px;
    }
    .word_back .word span {
        color: white;
        font-size: 20px;
        font-weight: bold;
    }
    .word_back .sentence {
        width: calc(90vmin - 123.6px);
        display: flex;
        justify-content: center;
        text-align: center;
    }
    .word_back .sentence span {
        color: white;
        font-size: 13px;
    }

    .re-item {
        width: calc(100vmin - 164px);
        height: calc(100vmin - 164px);
        position: relative;
    }

    .re-item .chinese_intro {
        position: absolute;
        bottom: 10px;
        right: 10px;
        background-color: rgba(0, 0, 0, 0.60);
        border-radius: 3px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 12px;
        color: white;
        z-index: 201;
    }

    .re-item-front,
    .re-item-back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
        backface-visibility: hidden;
        -webkit-transition: all 1.5s;
        -moz-transition: all 1.5s;
        -ms-transition: all 1.5s;
        -o-transition: all 1.5s;
        overflow: hidden;
    }

    .re-item-back {
        position: relative;
        transform: rotateY(-180deg);
        -webkit-transform: rotateY(-180deg);
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        text-align: center;
    }
    .re-item-back pre {
        padding-left: 10px;
        padding-right: 10px;
        font-weight: bold;
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .re-item-front.open {
        transform: rotateY(180deg);
        cursor: default;
        transition: transform 1s;
    }
    .re-item-back.open {
        transform: rotateY(0deg);
        cursor: default;
        transition: transform 1s;
    }

</style>
